import type { HTMLAttributes } from "react";

import { BreakpointProp } from "@/ui/lib";
import { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/
export const AVAILABLE_GRID_TAGS = [ "div", "ul", "ol", "article" ] as const;

export const GRID_COLUMNS_CLASS_MAP = {
  "12": "grid-cols-12",
} as const;

export const GRID_RESPONSIVE_COLUMNS_CLASS_MAP = {
  default: GRID_COLUMNS_CLASS_MAP,
  xl: {
    "12": "xl:grid-cols-12",
  },
} as const;

export const GRID_GAP_CLASS_MAP = {
  "none": "gap-0",
  "1.5": "gap-1.5",
  "2": "gap-2",
  "3": "gap-3",
  "4": "gap-4",
  "5": "gap-5",
  "8": "gap-8",
} as const;

export const GRID_RESPONSIVE_GAP_CLASS_MAP = {
  default: GRID_GAP_CLASS_MAP,
  xl: {
    "none": "xl:gap-0",
    "1.5": "xl:gap-1.5",
    "2": "xl:gap-2",
    "3": "xl:gap-3",
    "4": "xl:gap-4",
    "5": "xl:gap-5",
    "8": "xl:gap-8",
  },
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

type TGridTag = typeof AVAILABLE_GRID_TAGS[number];

export type TGridColumns = keyof typeof GRID_COLUMNS_CLASS_MAP;

export type TGridColumnsProp =
  BreakpointProp<typeof GRID_RESPONSIVE_COLUMNS_CLASS_MAP>;

export type TGridGap = keyof typeof GRID_GAP_CLASS_MAP;

export type TGridGapProp =
  BreakpointProp<typeof GRID_RESPONSIVE_GAP_CLASS_MAP>;

export type TGridProps = {
  tag?: TGridTag,
  columns?: TGridColumnsProp;
  gap?: TGridGapProp;
} & HTMLAttributes<HTMLElement>;

type TGridDefaultProps = DefinedDefaults<
  TGridProps,
  "columns" | "gap" | "tag"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const GRID_DEFAULTS = {
  tag: "div",
  columns: "12",
  gap: "4",
} satisfies TGridDefaultProps;
